














































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';

interface LicenseRecord {
  [key: string]: any;
}

interface DeleteRequestAlertState {
  type: 'success' | 'error' | 'info' | 'warning';
  message: string;
}

interface DeleteRequestJob {
  job_id: string;
  status: string;
  reports_status: string;
  reports_message: string;
  completed: boolean;
  created_at: string | null;
  updated_at: string | null;
  requested_by: string | null;
  tenant_id?: string | number | null;
  user_id?: string | number | null;
  reason?: string | null;
  no_backup?: boolean;
  [key: string]: any;
}

interface DeleteRequestFormState {
  tenant_id: string;
  user_id: string;
  reason: string;
  no_backup: boolean;
}

interface LicenseTableRow {
  row_id: string;
  user_id?: number | string;
  tenant_id?: number | string | null;
  user_name: string;
  email: string;
  phone: string;
  tenant_name: string;
  start_date: string | null;
  end_date: string | null;
  expires_at: string | null;
  days: number | string;
  is_deleted: boolean;
  deleted_at: string | null;
  mevcut_programlar: any[];
  gecmis_programlar: any[];
  latest_delete_request: DeleteRequestJob | null;
  latest_reset_request: DeleteRequestJob | null;
  source: LicenseRecord;
}

const LICENSE_TABLE_HEADERS = [
  { text: 'Kullanıcı', value: 'user_name' },
  { text: 'E-Posta', value: 'email' },
  { text: 'Mevcut Programlar', value: 'mevcut_programlar' },
  { text: 'Geçmiş Programlar', value: 'gecmis_programlar' },
  { text: 'Veri Silme Job', value: 'delete_request_status', sortable: false, width: 280 },
  { text: 'Veri Sıfırlama Job', value: 'reset_request_status', sortable: false, width: 280 },
  { text: 'İşlem', value: 'actions', sortable: false, align: 'end' },
];

const DELETE_REQUEST_POLL_INTERVAL = 5000;

@Component
export default class TumKullanicilar extends Vue {
  allLicenses: LicenseRecord[] = [];
  licenseHeaders = [...LICENSE_TABLE_HEADERS];
  licenseSearch = '';
  isLicenseLoading = false;
  licenseError: string | null = null;
  page = 1;
  perPage = 50;
  lastUpdated: Date | null = null;
  searchTimeout: ReturnType<typeof setTimeout> | null = null;

  deleteRequestDialog = false;
  deleteRequestConfirmDialog = false;
  selectedDeleteRow: LicenseTableRow | null = null;
  deleteRequestForm: DeleteRequestFormState = this.getInitialDeleteRequestForm();
  deleteRequestFormError: string | null = null;
  deleteRequestAlert: DeleteRequestAlertState | null = null;
  isCreatingDeleteRequest = false;
  activeDeleteCreateRowId: string | null = null;
  deleteRequestsByKey: Record<string, DeleteRequestJob> = {};
  deleteRequestPollers: Record<string, number> = {};

  resetRequestDialog = false;
  resetRequestConfirmDialog = false;
  selectedResetRow: LicenseTableRow | null = null;
  resetRequestForm: DeleteRequestFormState = this.getInitialResetRequestForm();
  resetRequestFormError: string | null = null;
  resetRequestAlert: DeleteRequestAlertState | null = null;
  isCreatingResetRequest = false;
  activeResetCreateRowId: string | null = null;
  resetRequestsByKey: Record<string, DeleteRequestJob> = {};
  resetRequestPollers: Record<string, number> = {};

  mounted(): void {
    this.refreshLicenses();
  }

  get lastUpdatedText(): string {
    if (!this.lastUpdated) {
      return '';
    }
    return new Intl.DateTimeFormat('tr-TR', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    }).format(this.lastUpdated);
  }

  get licensesEndpoint(): string {
    const baseUrl = this.$store?.state?.icwApiUrl || '';
    return `${baseUrl}admin/licenses`;
  }

  get searchEndpoint(): string {
    const baseUrl = this.$store?.state?.icwApiUrl || '';
    return `${baseUrl}admin/licenses/search`;
  }

  get deleteRequestEndpoint(): string {
    const baseUrl = this.$store?.state?.icwApiUrl || '';
    return `${baseUrl}admin/licenses/delete-request`;
  }

  get resetRequestEndpoint(): string {
    const baseUrl = this.$store?.state?.icwApiUrl || '';
    return `${baseUrl}admin/licenses/reset-request`;
  }

  get currentAdminUser(): string {
    const user = this.$store?.state?.user as any;
    const fullName = [user?.name, user?.lastname].filter(Boolean).join(' ').trim();
    const preferredValue = fullName || user?.email || user?.username || (user?.id ? String(user.id) : 'admin-panel');
    return this.toSafeHeaderValue(preferredValue) || 'admin-panel';
  }

  get tableRows(): LicenseTableRow[] {
    return this.allLicenses.map((license, index) => this.transformLicense(license, index));
  }

  get selectedDeleteRequestStatus(): DeleteRequestJob | null {
    if (!this.selectedDeleteRow) {
      return null;
    }
    return this.getLatestDeleteRequest(this.selectedDeleteRow.tenant_id, this.selectedDeleteRow.user_id);
  }

  get selectedResetRequestStatus(): DeleteRequestJob | null {
    if (!this.selectedResetRow) {
      return null;
    }
    return this.getLatestResetRequest(this.selectedResetRow.tenant_id);
  }

  async refreshLicenses(): Promise<void> {
    await this.fetchLicenses();
  }

  toSafeHeaderValue(value: unknown): string {
    const source = String(value ?? '').trim();
    if (!source) {
      return '';
    }

    const transliterated = source
      .replace(/İ/g, 'I')
      .replace(/ı/g, 'i')
      .replace(/Ş/g, 'S')
      .replace(/ş/g, 's')
      .replace(/Ğ/g, 'G')
      .replace(/ğ/g, 'g')
      .replace(/Ü/g, 'U')
      .replace(/ü/g, 'u')
      .replace(/Ö/g, 'O')
      .replace(/ö/g, 'o')
      .replace(/Ç/g, 'C')
      .replace(/ç/g, 'c')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

    return transliterated.replace(/[^\x20-\x7E]/g, '').trim();
  }

  async fetchLicenses(): Promise<void> {
    this.isLicenseLoading = true;
    this.licenseError = null;
    const search = this.licenseSearch.trim();
    try {
      const response = await this.$http.get(search ? this.searchEndpoint : this.licensesEndpoint, {
        params: {
          ...(search ? { search } : {}),
          page: this.page,
          per_page: this.perPage,
        },
      });
      const payload = Array.isArray(response.data)
        ? response.data
        : Array.isArray(response.data?.data)
          ? response.data.data
          : [];
      this.allLicenses = payload;
      this.lastUpdated = new Date();
      await this.fetchDeleteRequests();
      await this.fetchResetRequests();
    } catch (error) {
      console.error('Lisans bilgileri alınırken hata oluştu:', error);
      this.licenseError = 'Kullanıcı verileri alınamadı. Lütfen daha sonra tekrar deneyin.';
      this.$toast?.error('Kullanıcı verileri alınamadı.');
    } finally {
      this.isLicenseLoading = false;
    }
  }

  async fetchDeleteRequests(): Promise<void> {
    try {
      const response = await this.$http.get(this.deleteRequestEndpoint);
      const jobs = this.normalizeDeleteRequestCollection(response.data);
      this.ingestDeleteRequests(jobs);
    } catch (error) {
      console.error('Veri silme talepleri alınırken hata oluştu:', error);
    }
  }

  async fetchResetRequests(): Promise<void> {
    try {
      const response = await this.$http.get(this.resetRequestEndpoint);
      const jobs = this.normalizeDeleteRequestCollection(response.data);
      this.ingestResetRequests(jobs);
    } catch (error) {
      console.error('Veri sıfırlama talepleri alınırken hata oluştu:', error);
    }
  }

  onSearchInput(): void {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    this.searchTimeout = setTimeout(() => {
      this.page = 1;
      this.fetchLicenses();
    }, 350);
  }

  openDeleteRequestDialog(item: LicenseTableRow): void {
    this.deleteRequestAlert = null;
    this.deleteRequestFormError = null;
    this.selectedDeleteRow = item;
    this.activeDeleteCreateRowId = item.row_id;
    this.deleteRequestForm = {
      tenant_id: item.tenant_id ? String(item.tenant_id) : '',
      user_id: item.user_id ? String(item.user_id) : '',
      reason: 'KVKK veri silme talebi',
      no_backup: false,
    };
    this.deleteRequestDialog = true;
  }

  closeDeleteRequestDialog(): void {
    this.deleteRequestDialog = false;
    this.deleteRequestConfirmDialog = false;
    this.selectedDeleteRow = null;
    this.activeDeleteCreateRowId = null;
    this.deleteRequestFormError = null;
    this.deleteRequestForm = this.getInitialDeleteRequestForm();
  }

  openDeleteRequestConfirmDialog(): void {
    if (!this.deleteRequestForm.tenant_id.trim() || !this.deleteRequestForm.user_id.trim()) {
      this.deleteRequestFormError = 'tenant_id ve user_id zorunludur.';
      return;
    }
    this.deleteRequestFormError = null;
    this.deleteRequestConfirmDialog = true;
  }

  async submitDeleteRequest(): Promise<void> {
    if (!this.selectedDeleteRow) {
      return;
    }
    if (!this.deleteRequestForm.tenant_id.trim() || !this.deleteRequestForm.user_id.trim()) {
      this.deleteRequestFormError = 'tenant_id ve user_id zorunludur.';
      return;
    }

    this.isCreatingDeleteRequest = true;
    this.deleteRequestFormError = null;

    const payload = {
      tenant_id: this.deleteRequestForm.tenant_id.trim(),
      user_id: Number.isNaN(Number(this.deleteRequestForm.user_id))
        ? this.deleteRequestForm.user_id.trim()
        : Number(this.deleteRequestForm.user_id),
      reason: this.deleteRequestForm.reason.trim() || undefined,
      no_backup: this.deleteRequestForm.no_backup,
    };

    try {
      const response = await this.$http.post(this.deleteRequestEndpoint, payload, {
        headers: {
          'X-Admin-User': this.currentAdminUser,
        },
      });
      const job = this.normalizeDeleteRequestJob(response.data?.data ?? response.data);
      if (!job?.job_id) {
        throw new Error('job_id bulunamadı');
      }

      this.storeDeleteRequest(job, payload.tenant_id, payload.user_id);
      this.deleteRequestAlert = {
        type: 'success',
        message: 'Silme isteği sıraya alındı.',
      };
      this.$toast?.success('Silme isteği sıraya alındı.');
      this.startDeleteRequestPolling(job.job_id, payload.tenant_id, payload.user_id);
      this.closeDeleteRequestDialog();
    } catch (error) {
      console.error('Veri silme talebi oluşturulurken hata oluştu:', error);
      const requestError: any = error;
      const apiMessage = requestError?.response?.data?.message || requestError?.response?.data?.data?.reports_message;
      const message = apiMessage || 'Veri silme talebi oluşturulamadı. Lütfen tekrar deneyin.';
      this.deleteRequestFormError = message;
      this.deleteRequestAlert = {
        type: 'error',
        message,
      };
      this.$toast?.error(message);
    } finally {
      this.deleteRequestConfirmDialog = false;
      this.isCreatingDeleteRequest = false;
      this.activeDeleteCreateRowId = null;
    }
  }

  openResetRequestDialog(item: LicenseTableRow): void {
    this.resetRequestAlert = null;
    this.resetRequestFormError = null;
    this.selectedResetRow = item;
    this.activeResetCreateRowId = item.row_id;
    this.resetRequestForm = {
      tenant_id: item.tenant_id ? String(item.tenant_id) : '',
      user_id: '',
      reason: 'Admin reset',
      no_backup: false,
    };
    this.resetRequestDialog = true;
  }

  closeResetRequestDialog(): void {
    this.resetRequestDialog = false;
    this.resetRequestConfirmDialog = false;
    this.selectedResetRow = null;
    this.activeResetCreateRowId = null;
    this.resetRequestFormError = null;
    this.resetRequestForm = this.getInitialResetRequestForm();
  }

  openResetRequestConfirmDialog(): void {
    if (!this.resetRequestForm.tenant_id.trim()) {
      this.resetRequestFormError = 'tenant_id zorunludur.';
      return;
    }
    this.resetRequestFormError = null;
    this.resetRequestConfirmDialog = true;
  }

  async submitResetRequest(): Promise<void> {
    if (!this.selectedResetRow) {
      return;
    }
    if (!this.resetRequestForm.tenant_id.trim()) {
      this.resetRequestFormError = 'tenant_id zorunludur.';
      return;
    }

    this.isCreatingResetRequest = true;
    this.resetRequestFormError = null;

    const payload = {
      tenant_id: this.resetRequestForm.tenant_id.trim(),
      user_id: null,
      reason: this.resetRequestForm.reason.trim() || 'Admin reset',
      no_backup: this.resetRequestForm.no_backup,
    };

    try {
      const response = await this.$http.post(this.resetRequestEndpoint, payload, {
        headers: {
          'X-Admin-User': this.currentAdminUser,
        },
      });
      const job = this.normalizeDeleteRequestJob(response.data?.data ?? response.data);
      if (!job?.job_id) {
        throw new Error('job_id bulunamadı');
      }

      this.storeResetRequest(job, payload.tenant_id);
      this.resetRequestAlert = {
        type: 'success',
        message: 'Veri sıfırlama isteği sıraya alındı.',
      };
      this.$toast?.success('Veri sıfırlama isteği sıraya alındı.');
      this.startResetRequestPolling(job.job_id, payload.tenant_id);
      this.closeResetRequestDialog();
    } catch (error) {
      console.error('Veri sıfırlama talebi oluşturulurken hata oluştu:', error);
      const requestError: any = error;
      const apiMessage = requestError?.response?.data?.message || requestError?.response?.data?.data?.reports_message;
      const message = apiMessage || 'Veri sıfırlama talebi oluşturulamadı. Lütfen tekrar deneyin.';
      this.resetRequestFormError = message;
      this.resetRequestAlert = {
        type: 'error',
        message,
      };
      this.$toast?.error(message);
    } finally {
      this.resetRequestConfirmDialog = false;
      this.isCreatingResetRequest = false;
      this.activeResetCreateRowId = null;
    }
  }

  async fetchDeleteRequestByJobId(
    jobId: string,
    tenantId?: string | number | null,
    userId?: string | number | null
  ): Promise<DeleteRequestJob | null> {
    try {
      const response = await this.$http.get(`${this.deleteRequestEndpoint}/${jobId}`);
      const job = this.normalizeDeleteRequestJob(response.data?.data ?? response.data);
      if (!job) {
        return null;
      }
      this.storeDeleteRequest(job, tenantId, userId);
      return job;
    } catch (error) {
      console.error(`Veri silme job durumu alınırken hata oluştu: ${jobId}`, error);
      return null;
    }
  }

  startDeleteRequestPolling(
    jobId: string,
    tenantId?: string | number | null,
    userId?: string | number | null
  ): void {
    this.stopDeleteRequestPolling(jobId);

    const poll = async () => {
      const job = await this.fetchDeleteRequestByJobId(jobId, tenantId, userId);
      if (!job) {
        this.stopDeleteRequestPolling(jobId);
        return;
      }
      if (this.isDeleteRequestTerminal(job)) {
        if (job.status === 'ERROR' && job.reports_message) {
          this.deleteRequestAlert = {
            type: 'error',
            message: job.reports_message,
          };
        }
        this.stopDeleteRequestPolling(jobId);
        return;
      }
      this.deleteRequestPollers[jobId] = window.setTimeout(poll, DELETE_REQUEST_POLL_INTERVAL);
    };

    this.deleteRequestPollers[jobId] = window.setTimeout(poll, DELETE_REQUEST_POLL_INTERVAL);
  }

  stopDeleteRequestPolling(jobId: string): void {
    if (!this.deleteRequestPollers[jobId]) {
      return;
    }
    clearTimeout(this.deleteRequestPollers[jobId]);
    this.$delete(this.deleteRequestPollers, jobId);
  }

  stopAllDeleteRequestPolling(): void {
    Object.keys(this.deleteRequestPollers).forEach((jobId) => this.stopDeleteRequestPolling(jobId));
  }

  async fetchResetRequestByJobId(
    jobId: string,
    tenantId?: string | number | null
  ): Promise<DeleteRequestJob | null> {
    try {
      const response = await this.$http.get(`${this.resetRequestEndpoint}/${jobId}`);
      const job = this.normalizeDeleteRequestJob(response.data?.data ?? response.data);
      if (!job) {
        return null;
      }
      this.storeResetRequest(job, tenantId);
      return job;
    } catch (error) {
      console.error(`Veri sıfırlama job durumu alınırken hata oluştu: ${jobId}`, error);
      return null;
    }
  }

  startResetRequestPolling(jobId: string, tenantId?: string | number | null): void {
    this.stopResetRequestPolling(jobId);

    const poll = async () => {
      const job = await this.fetchResetRequestByJobId(jobId, tenantId);
      if (!job) {
        this.stopResetRequestPolling(jobId);
        return;
      }
      if (this.isRequestTerminal(job)) {
        if (job.status === 'ERROR' && job.reports_message) {
          this.resetRequestAlert = {
            type: 'error',
            message: job.reports_message,
          };
        }
        this.stopResetRequestPolling(jobId);
        return;
      }
      this.resetRequestPollers[jobId] = window.setTimeout(poll, DELETE_REQUEST_POLL_INTERVAL);
    };

    this.resetRequestPollers[jobId] = window.setTimeout(poll, DELETE_REQUEST_POLL_INTERVAL);
  }

  stopResetRequestPolling(jobId: string): void {
    if (!this.resetRequestPollers[jobId]) {
      return;
    }
    clearTimeout(this.resetRequestPollers[jobId]);
    this.$delete(this.resetRequestPollers, jobId);
  }

  stopAllResetRequestPolling(): void {
    Object.keys(this.resetRequestPollers).forEach((jobId) => this.stopResetRequestPolling(jobId));
  }

  ingestDeleteRequests(jobs: DeleteRequestJob[]): void {
    jobs.forEach((job) => {
      if (!job?.job_id) {
        return;
      }
      this.storeDeleteRequest(job, job.tenant_id, job.user_id);
      if (!this.isDeleteRequestTerminal(job)) {
        this.startDeleteRequestPolling(job.job_id, job.tenant_id, job.user_id);
      } else {
        this.stopDeleteRequestPolling(job.job_id);
      }
    });
  }

  ingestResetRequests(jobs: DeleteRequestJob[]): void {
    jobs.forEach((job) => {
      if (!job?.job_id) {
        return;
      }
      this.storeResetRequest(job, job.tenant_id);
      if (!this.isRequestTerminal(job)) {
        this.startResetRequestPolling(job.job_id, job.tenant_id);
      } else {
        this.stopResetRequestPolling(job.job_id);
      }
    });
  }

  storeDeleteRequest(
    job: DeleteRequestJob,
    tenantId?: string | number | null,
    userId?: string | number | null
  ): void {
    const resolvedTenantId = tenantId ?? job.tenant_id ?? null;
    const resolvedUserId = userId ?? job.user_id ?? null;
    const normalizedJob: DeleteRequestJob = {
      ...job,
      tenant_id: resolvedTenantId,
      user_id: resolvedUserId,
      completed: Boolean(job.completed || job.status === 'COMPLETED'),
    };

    if (resolvedTenantId == null || resolvedUserId == null) {
      return;
    }

    const key = this.getDeleteRequestKey(resolvedTenantId, resolvedUserId);
    const existingJob = this.deleteRequestsByKey[key];
    if (!existingJob || this.isJobNewer(normalizedJob, existingJob)) {
      this.$set(this.deleteRequestsByKey, key, normalizedJob);
    }
  }

  getLatestDeleteRequest(
    tenantId?: string | number | null,
    userId?: string | number | null
  ): DeleteRequestJob | null {
    if (tenantId == null || userId == null) {
      return null;
    }
    return this.deleteRequestsByKey[this.getDeleteRequestKey(tenantId, userId)] || null;
  }

  storeResetRequest(job: DeleteRequestJob, tenantId?: string | number | null): void {
    const resolvedTenantId = tenantId ?? job.tenant_id ?? null;
    const normalizedJob: DeleteRequestJob = {
      ...job,
      tenant_id: resolvedTenantId,
      user_id: null,
      completed: Boolean(job.completed || job.status === 'COMPLETED'),
    };

    if (resolvedTenantId == null) {
      return;
    }

    const key = this.getResetRequestKey(resolvedTenantId);
    const existingJob = this.resetRequestsByKey[key];
    if (!existingJob || this.isJobNewer(normalizedJob, existingJob)) {
      this.$set(this.resetRequestsByKey, key, normalizedJob);
    }
  }

  getLatestResetRequest(tenantId?: string | number | null): DeleteRequestJob | null {
    if (tenantId == null) {
      return null;
    }
    return this.resetRequestsByKey[this.getResetRequestKey(tenantId)] || null;
  }

  getDeleteRequestKey(tenantId: string | number, userId: string | number): string {
    return `${tenantId}::${userId}`;
  }

  getResetRequestKey(tenantId: string | number): string {
    return String(tenantId);
  }

  isJobNewer(nextJob: DeleteRequestJob, currentJob: DeleteRequestJob): boolean {
    const nextTime = new Date(nextJob.updated_at || nextJob.created_at || 0).getTime();
    const currentTime = new Date(currentJob.updated_at || currentJob.created_at || 0).getTime();
    return nextTime >= currentTime;
  }

  isDeleteRequestTerminal(job: DeleteRequestJob): boolean {
    return job.completed || job.status === 'COMPLETED' || job.status === 'ERROR';
  }

  isDeleteRequestCompleted(job: DeleteRequestJob | null): boolean {
    return Boolean(job && (job.completed || job.status === 'COMPLETED'));
  }

  isRequestTerminal(job: DeleteRequestJob): boolean {
    return this.isDeleteRequestTerminal(job);
  }

  isRequestCompleted(job: DeleteRequestJob | null): boolean {
    return this.isDeleteRequestCompleted(job);
  }

  deleteStatusLabel(status?: string | null): string {
    switch (status) {
      case 'WAITING':
        return 'Sırada';
      case 'PENDING':
        return 'İşleniyor';
      case 'ERROR':
        return 'Hata';
      case 'COMPLETED':
        return 'Tamamlandı';
      default:
        return status || '-';
    }
  }

  deleteStatusColor(job: DeleteRequestJob | null): string {
    if (!job) {
      return 'grey';
    }
    switch (job.status) {
      case 'WAITING':
        return 'orange darken-2';
      case 'PENDING':
        return 'blue darken-2';
      case 'ERROR':
        return 'red darken-2';
      case 'COMPLETED':
        return 'green darken-2';
      default:
        return 'grey darken-1';
    }
  }

  requestStatusLabel(status?: string | null): string {
    return this.deleteStatusLabel(status);
  }

  requestStatusColor(job: DeleteRequestJob | null): string {
    return this.deleteStatusColor(job);
  }

  transformLicense(license: LicenseRecord, index: number): LicenseTableRow {
    const user = license.user || license.kullanici || license.customer || {};
    const tenant = license.tenant || license.buro || license.office || {};
    const firstName = user.name ?? user.first_name ?? license.name ?? '';
    const lastName = user.lastname ?? user.last_name ?? license.lastname ?? '';
    const fullName = [firstName, lastName].filter(Boolean).join(' ')
      || user.full_name
      || license.user_name
      || license.full_name
      || '-';

    const email = user.email ?? license.email ?? '-';
    const phone = user.phone ?? user.phone_number ?? license.phone ?? license.phone_number ?? '-';
    const isDeleted = Boolean(user.is_deleted ?? license.is_deleted ?? false);
    const deletedAt = user.deleted_at ?? license.deleted_at ?? null;
    const tenantName = tenant.name
      ?? tenant.buro_adi
      ?? tenant.office_name
      ?? license.buro_name
      ?? license.tenant_name
      ?? '-';

    const startDateRaw = license.start_date ?? license.license_start ?? license.begin_date ?? null;
    const endDateRaw = license.end_date ?? license.license_end ?? license.license_end_date ?? null;
    const startDate = this.stripTime(startDateRaw);
    const endDate = this.stripTime(endDateRaw);

    let expiresAtRaw = null;
    if (Array.isArray(license.gecmis_programlar) && license.gecmis_programlar.length > 0) {
      const lastProgram = license.gecmis_programlar[license.gecmis_programlar.length - 1];
      expiresAtRaw = lastProgram.end_date ?? null;
    }

    const expiresAt = this.stripTime(
      expiresAtRaw ??
      endDateRaw ??
      license.expires_at ??
      license.license_end ??
      license.license_end_date ??
      null
    );
    const days = license.days ?? license.expire_days ?? license.expire_day ?? license.kalan_gun ?? '-';
    const userId = user.user_id
      ?? license.user_id
      ?? user.sso_id
      ?? null;
    const tenantId = user.tenant_id
      ?? tenant.tenant_id
      ?? license.tenant_id
      ?? tenant.buro_id
      ?? license.buro_id
      ?? license.office_id
      ?? null;
    const rowId = `${userId ?? 'row'}-${tenantId ?? 'tenant'}-${index}`;

    return {
      row_id: rowId,
      user_id: userId,
      tenant_id: tenantId,
      user_name: fullName,
      email,
      phone,
      tenant_name: tenantName,
      start_date: startDate,
      end_date: endDate,
      expires_at: expiresAt,
      days,
      is_deleted: isDeleted,
      deleted_at: deletedAt,
      mevcut_programlar: this.normalizePrograms(
        license.mevcut_programlar ?? license.programlar?.aktif ?? license.programlar ?? []
      ),
      gecmis_programlar: this.normalizePrograms(
        license.gecmis_programlar ?? license.programlar?.gecmis ?? []
      ),
      latest_delete_request: this.getLatestDeleteRequest(tenantId, userId),
      latest_reset_request: this.getLatestResetRequest(tenantId),
      source: license,
    };
  }

  normalizeDeleteRequestCollection(payload: any): DeleteRequestJob[] {
    if (Array.isArray(payload)) {
      return payload.map((item) => this.normalizeDeleteRequestJob(item)).filter(Boolean) as DeleteRequestJob[];
    }

    const collection = payload?.data ?? payload?.jobs ?? payload?.items ?? payload;
    if (Array.isArray(collection)) {
      return collection.map((item) => this.normalizeDeleteRequestJob(item)).filter(Boolean) as DeleteRequestJob[];
    }

    return [];
  }

  normalizeDeleteRequestJob(payload: any): DeleteRequestJob | null {
    if (!payload || typeof payload !== 'object') {
      return null;
    }

    return {
      ...payload,
      job_id: payload.job_id ?? payload.jobId ?? '',
      status: payload.status ?? payload.job_status ?? '-',
      reports_status: payload.reports_status ?? payload.report_status ?? '-',
      reports_message: payload.reports_message ?? payload.report_message ?? '',
      completed: Boolean(payload.completed || payload.status === 'COMPLETED'),
      created_at: payload.created_at ?? null,
      updated_at: payload.updated_at ?? null,
      requested_by: payload.requested_by ?? payload.admin_user ?? null,
      tenant_id: payload.tenant_id ?? payload.tenantId ?? payload.tenant?.id ?? null,
      user_id: payload.user_id ?? payload.userId ?? payload.user?.id ?? null,
    };
  }

  normalizePrograms(programs: any): any[] {
    if (!programs) {
      return [];
    }
    if (Array.isArray(programs)) {
      return programs.filter((program) => program !== null && program !== undefined);
    }
    if (typeof programs === 'string') {
      return programs
        .split(',')
        .map((program) => program.trim())
        .filter((program) => program.length > 0);
    }
    if (typeof programs === 'object') {
      return Object.values(programs);
    }
    return [programs];
  }

  stripTime(value: any): string | null {
    if (!value) {
      return null;
    }
    if (typeof value === 'string') {
      const isoMatch = value.match(/^(\d{4}-\d{2}-\d{2})/);
      if (isoMatch) {
        return isoMatch[1];
      }
      const spaceSplit = value.split(' ');
      if (spaceSplit.length > 0 && /\d{4}-\d{2}-\d{2}/.test(spaceSplit[0])) {
        return spaceSplit[0];
      }
    }
    const date = new Date(value);
    if (!Number.isNaN(date.getTime())) {
      return date.toISOString().split('T')[0];
    }
    return typeof value === 'string' ? value : null;
  }

  formatDate(value: any): string {
    if (!value) {
      return '-';
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return value;
    }
    return new Intl.DateTimeFormat('tr-TR', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    }).format(date);
  }

  formatDateTime(value: any): string {
    if (!value) {
      return '-';
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return value;
    }
    return new Intl.DateTimeFormat('tr-TR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  }

  getInitialDeleteRequestForm(): DeleteRequestFormState {
    return {
      tenant_id: '',
      user_id: '',
      reason: '',
      no_backup: false,
    };
  }

  getInitialResetRequestForm(): DeleteRequestFormState {
    return {
      tenant_id: '',
      user_id: '',
      reason: 'Admin reset',
      no_backup: false,
    };
  }

  get footerProps() {
    return {
      'items-per-page-options': [15, 30, 50, 100],
      showFirstLastPage: true,
    };
  }

  onPageChange(newPage: number): void {
    if (this.page === newPage) {
      return;
    }
    this.page = newPage;
    this.fetchLicenses();
  }

  onItemsPerPageChange(newItemsPerPage: number): void {
    if (this.perPage === newItemsPerPage) {
      return;
    }
    this.perPage = newItemsPerPage;
    this.page = 1;
    this.fetchLicenses();
  }

  beforeDestroy(): void {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    this.stopAllDeleteRequestPolling();
    this.stopAllResetRequestPolling();
  }
}
